import { FormStateMap, reducer as reduxFormReducer } from 'redux-form'
import { Reducer } from 'interfaces/index'
/*

const providerLoginFormReducer: Reducer<FormState | null> = (state: FormState, action: Action) => {
  if (
    state && state.values
    && action.type === TOGGLE_AUTHENTICATION_FORM && !action.payload.show
  ) {
    const {
      name: payloadStageName,
      sessionId: payloadSessionId,
      authenticationId: payloadAuthenticationId,
    } = action.payload.stage
    const { stageName, sessionId, authenticationId } = state.values

    if (
      stageName === payloadStageName
      && Number(sessionId) === payloadSessionId
      && Number(authenticationId) === payloadAuthenticationId
    ) {
      return null
    }
  }

  return state
}
*/

const formReducer: Reducer<FormStateMap> = reduxFormReducer.plugin({
  // [FORM_LINKAGE_AUTHENTICATION]: providerLoginFormReducer,
})

export default formReducer
